import { DataHubActions } from 'src/modules/datahub/actions'
import { DataHubEntities } from 'src/modules/datahub/entities'
import BaseSchema from 'src/modules/datahub/schemas/baseSchema'

import { EventNames, ScreenNames } from '../../types'

class LimitPublicationSchema extends BaseSchema {
  action: DataHubActions
  entity: DataHubEntities
  eventName: EventNames
  screenName: ScreenNames
  failureKind?: string

  constructor() {
    super()
    this.entity = DataHubEntities.COMMUNITY
    this.action = DataHubActions.SETUP
    this.eventName = EventNames.CLICK_TO_LIMIT_PUBLICATION
    this.screenName = ScreenNames.COMMUNITY_CREATION_MODAL
  }

  getDataHubEventData(): Record<string, unknown> {
    return {
      ...super.prepare(),
      eventName: this.eventName,
      screenName: this.screenName
    }
  }
}

export default LimitPublicationSchema
